import { render } from "./Audits.vue?vue&type=template&id=2d933966&scoped=true"
import script from "./Audits.vue?vue&type=script&lang=js"
export * from "./Audits.vue?vue&type=script&lang=js"

import "./Audits.vue?vue&type=style&index=0&id=2d933966&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d933966"]])

export default __exports__